import React from 'react'

import { bemJoin } from 'bem-join'

import { PageTab, PageTabProps } from '@app/lib/layout/PageTabs/PageTab'

import './PageTabs.scss'

export type PageTabsProps = {
  tabs: Array<PageTabProps | false | undefined>
}

export const PageTabs = ({ tabs }: PageTabsProps) => {
  const b = bemJoin('page-tabs')

  return (
    <nav className={b()}>
      <ul>
        {tabs.filter(Boolean).map((tab: PageTabProps, index) => (
          <li key={index}>
            <PageTab
              counter={tab.counter}
              link={tab.link}
              isSelected={tab.isSelected}
              label={tab.label}
              icon={tab.icon}
            />
          </li>
        ))}
      </ul>
    </nav>
  )
}
